const C = '/careers';
export const CAREERS_ASSETS = {
  sprayWoman: `${C}/spray-woman-cutout-v1.png`,
  standardCleaner: `${C}/guru-standard-cleaner-edited-v1.png`,
  clipboardGuru: `${C}/clipboard-guru.png`,
  posters: {
    prepared: '/homepage2/media/prepared-gloves.jpg',
    systematic: '/homepage2/media/systematic-office.jpg',
    detail: '/homepage2/media/detail-driven.jpg',
    verified: '/homepage2/media/verified.jpg',
  },
};
